import "@babel/polyfill";

require('./bootstrap');

window.Vue = require('vue');

import Vue from 'vue'
import Vuetify from 'vuetify'
import store from './store/index'
import '@mdi/font/css/materialdesignicons.css'

import Auth from './Helpers/auth'
window.Auth = Auth // Token and User

import Lang from './Helpers/lang'
window.Lang = Lang // App language

import Loading from './Helpers/loading'
window.Load = Loading // App Loading

import Devices from './Helpers/devices'
window.Devices = Devices // App Devices

window.URL = window.location.origin // website url

window.EventBus = new Vue();

Vue.use(Vuetify, {
  theme: {
    red: '#e51836',
    blue: '#0062b2',
  },
  iconfont: 'mdi',
  rtl: Lang.get() === 'he' ? true : false,
})

if (Auth.g()) axios.defaults.headers.common['Authorization'] = `Bearer ${Auth.g().token}` // pass token for every request

Vue.component('AppHome', require('./components/AppHome.vue').default);

Vue.config.productionTip = false;

import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';
// const socket = io('http://127.0.0.1:3006', {
// const socket = io('https://yssio.switchq.com:3007', {
const socket = io('https://yssio.switchq.com:3007', {
   secure: true,
   query: "email="+Auth.d().email+"&token=" + (Auth.g() ? Auth.g().token : "")
});
Vue.use(VueSocketIOExt, socket);

import router from './Router/router.js'

const app = new Vue({
    el: '#app',
    store,
    router
});
